import React, { Component } from 'react'
import { Dialog, DialogContent, DialogActions, Button } from '@material-ui/core';
import { BtnForm } from '../../../general/BotonesAccion';
import { mostrarError } from '../../../../global/js/funciones';
import AppBarModal from '../../../general/AppBarModal';
import CustomDropzone from '../../../general/CustomDropzone';
import TareasTerminadas from "../../../general/TareasTerminadas";
import emma_w from '../../../../global/imagenes/emma_w.png';
import FormatoSesionesDetalle from '../forms/FormatoSesionesDetalle';
import { postAdjuntosBienestar } from '../services/bienestarDetalleService';
import MensajeSinPermiso from './detalle/MensajeSinPermiso';
import { MENSAJE_SIN_PERMISO_PROFESIONAL } from '../helpers/bienestarAccesoPermisos';

export default class BienestarArchivosAdjuntos extends Component {

  constructor(props) {
    super(props)
    this.state = {
      cargando: false,
      archivos: []
    }
  }

  async componentDidUpdate(prevProps) {
    const { modalMaterialApoyoBienestar } = this.props;
    if (prevProps.modalMaterialApoyoBienestar !== modalMaterialApoyoBienestar) {
      if (!modalMaterialApoyoBienestar) {
        this.setState({ archivos: [] });
      }
    }
  }

  agregarArchivos = (files) => {
    const { archivos } = this.state;
    const { actualizarMensaje } = this.props;
    const nuevosArchivos = [...archivos, ...files];
    this.setState({ archivos: nuevosArchivos });
    if (actualizarMensaje) {
      actualizarMensaje({ 
        titulo: `${files.length} archivo(s) añadido(s)`, 
        tipo: 'success', 
        mostrar: true, 
        tiempo: 2000 
      });
    }
  }

  eliminarArchivo = (index) => {
    const { archivos } = this.state;
    const archivosActualizados = archivos.filter((_, i) => i !== index);
    this.setState({ archivos: archivosActualizados });
  }

  guardarMaterialApoyo = async () => {
    const { bienestar_id, mostrarModalMaterialApoyoBienestar, actualizarMensaje, tipoModal, puedeVerContenido = true } = this.props;
    const { archivos } = this.state;
    const esDocumentosExtras =
      (tipoModal && typeof tipoModal === 'object' && tipoModal.tipo === 'documentos_extras') ||
      (typeof tipoModal === 'string' && tipoModal === 'documentos_extras');
    const puedeVer = esDocumentosExtras ? true : puedeVerContenido;

    if (!puedeVer) {
      if (actualizarMensaje) {
        actualizarMensaje({ 
          titulo: MENSAJE_SIN_PERMISO_PROFESIONAL,
          tipo: 'info', 
          mostrar: true, 
          tiempo: 4000 
        });
      }
      return;
    }

    if (!archivos || archivos.length === 0) {
      actualizarMensaje({ 
        titulo: 'Debe seleccionar al menos un archivo', 
        tipo: 'info', 
        mostrar: true, 
        tiempo: 3000 
      });
      return;
    }

    this.setState({ cargando: true });

    try {
      const form = new FormData();
      archivos.forEach(archivo => {
        form.append('archivos', archivo);
      });
      let tipoAdjunto = 2;
      if (
        (tipoModal && typeof tipoModal === 'object' && tipoModal.tipo === 'documentos_extras') ||
        (typeof tipoModal === 'string' && tipoModal === 'documentos_extras')
      ) {
        tipoAdjunto = 3;
      }
      form.append('tipo_adjunto', tipoAdjunto);

      const { error, estado, resp } = await postAdjuntosBienestar(bienestar_id, form);
      if (!error && estado === 201) {
        actualizarMensaje({ 
          titulo: 'Archivos guardados correctamente', 
          tipo: 'success', 
          mostrar: true, 
          tiempo: 3000 
        });
        this.setState({ archivos: [], cargando: false });
        mostrarModalMaterialApoyoBienestar(false);
      } else {
        const titulo = resp?.titulo || mostrarError(resp) || 'Error al guardar los archivos';
        actualizarMensaje({ 
          titulo, 
          tipo: 'error', 
          mostrar: true, 
          tiempo: 3000 
        });
        this.setState({ cargando: false });
      }
    } catch (err) {
      actualizarMensaje({ 
        titulo: 'Error al guardar los archivos', 
        tipo: 'error', 
        mostrar: true, 
        tiempo: 3000 
      });
      this.setState({ cargando: false });
    }
  }

  render() {
    const { modalMaterialApoyoBienestar, mostrarModalMaterialApoyoBienestar, actualizarMensaje, bienestar_id, tipoModal, puedeVerContenido = true } = this.props;
    const { cargando, archivos } = this.state;
    const esDocumentosExtras =
      (tipoModal && typeof tipoModal === 'object' && tipoModal.tipo === 'documentos_extras') ||
      (typeof tipoModal === 'string' && tipoModal === 'documentos_extras');
    const puedeVer = esDocumentosExtras ? true : puedeVerContenido;

    // Si es formulario de detalles de sesiones, mostrar componente especial
    if (tipoModal === 'formatoSesiones') {
      return (
        <Dialog open={modalMaterialApoyoBienestar} onClose={() => mostrarModalMaterialApoyoBienestar(false)} fullWidth={true} maxWidth="md">
          <AppBarModal titulo="Detalles de Formatos por Sesión" mostrarModal={() => mostrarModalMaterialApoyoBienestar(false)} titulo_accion="" />
          <DialogContent style={{ padding: 12, overflowX: 'hidden' }} className="scroll">
            {puedeVer
              ? <FormatoSesionesDetalle bienestar_id={bienestar_id} />
              : (
                <div style={{ padding: 12 }}>
                  <MensajeSinPermiso mensaje={MENSAJE_SIN_PERMISO_PROFESIONAL} />
                </div>
              )
            }
          </DialogContent>
          <DialogActions>
            <BtnForm texto="Cerrar" callback={() => mostrarModalMaterialApoyoBienestar(false)} />
          </DialogActions>
        </Dialog>
      );
    }

    // Título dinámico según tipoModal
    let tituloModal = 'Material de Apoyo';
    if (
      (tipoModal && typeof tipoModal === 'object' && tipoModal.tipo === 'documentos_extras') ||
      (typeof tipoModal === 'string' && tipoModal === 'documentos_extras')
    ) {
      tituloModal = 'Documentos Extras';
    }

    // Modo original: Material de Apoyo (adjuntos)
    return (
      <div>
        <Dialog open={modalMaterialApoyoBienestar} onClose={() => mostrarModalMaterialApoyoBienestar(false)} fullWidth={true} maxWidth="sm">
          <AppBarModal titulo={tituloModal} mostrarModal={() => mostrarModalMaterialApoyoBienestar(false)} titulo_accion="" />
          <DialogContent style={{ padding: 0, overflowX: 'hidden' }} className="scroll">
            {
              !cargando ? (
                puedeVer ? (
                  <CustomDropzone 
                    archivos={archivos} 
                    addFunction={this.agregarArchivos} 
                    deleteFunction={this.eliminarArchivo}
                    actualizarMensaje={actualizarMensaje}
                    mensaje="Arrastra y suelta archivos aquí o haz clic para seleccionar"
                  />
                ) : (
                  <div style={{ padding: 12 }}>
                    <MensajeSinPermiso mensaje={MENSAJE_SIN_PERMISO_PROFESIONAL} />
                  </div>
                )
              ) : (
                <TareasTerminadas mensaje='Guardando...' marginTop='7%' imagen={emma_w} widthImg="7%" cargando={true} />
              )
            }
          </DialogContent>
          <DialogActions>
            <BtnForm texto="Cerrar" callback={() => mostrarModalMaterialApoyoBienestar(false)} />
            <Button 
              color="primary" 
              onClick={this.guardarMaterialApoyo}
              disabled={cargando || archivos.length === 0 || !puedeVer}
            >
              Guardar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}
